module.exports = __webpack_public_path__ + "img/city.4e3deec4.png";